<nb-card class="fees-dialog">
  <nb-card-header class="fees-dialog-header">
    <button (click)="closeDialog()" class="btn border-0 m-0 p-0 w-100 text-end mt-1 fees-close-button" type="button">
      <i class="bi bi-x-square-fill m-0"></i>
    </button>
    <div class="fees-dialog-title">
      <span>{{ 'Branch Settings' | translate }}</span>
      <h3 *ngIf="isAddFeesSettings">{{ 'Add Fees Settings' | translate }}</h3>
      <h3 *ngIf="isEditFeesSettings">{{ 'Update Fees Settings' | translate }}</h3>
    </div>
  </nb-card-header>
  <nb-card-body class="fees-dialog-body">
    <form
      action="javascript:"
      class="reset fees-form"
      [formGroup]="feesForm"
      [ngClass]="{ 'was-validated': submitted, rtl: language.isArabic }">
      <div formArrayName="feesArray" class="fees-list">
        <div *ngFor="let fee of feesArray.controls; let i = index" [formGroupName]="i" class="fee-card">
          <div class="fee-card-header">
            <div>
              <span class="fee-index">{{ i + 1 }}</span>
              <strong>{{ 'Fee' | translate }}</strong>
            </div>
            <button
              (click)="removeFee(i)"
              type="button"
              class="btn fee-remove-button"
              [attr.aria-label]="'Remove Fee' | translate">
              <i class="bi bi-trash"></i>
            </button>
          </div>

          <div class="fee-field">
            <label class="form-label">{{ 'Title' | translate }}</label>
            <input
              required
              class="form-control input-control"
              [ngClass]="{ 'is-invalid': submitted && fee.get('title').errors }"
              formControlName="title"
              placeholder="{{ 'Please enter Title' | translate }}" />
          </div>
      
          <div class="fee-grid">
            <div class="fee-field">
              <label class="form-label">{{ 'Type' | translate }}</label>
              <select
                class="form-select input-control"
                formControlName="type"
                required
                [ngClass]="{ 'is-invalid': submitted && fee.get('type').errors }">
                <option *ngFor="let status of feesTypeEnum; index as i" [value]="status.value">
                  {{ status.title | translate }}
                </option>
              </select>
            </div>
      
            <div class="fee-field">
              <label class="form-label">{{ 'Amount' | translate }}</label>
              <div class="input-group">
                <input
                  required
                  type="number"
                  class="form-control input-control"
                  [ngClass]="{ 'is-invalid': submitted && fee.get('amount').errors }"
                  formControlName="amount" />
                <span *ngIf="isPercent(i)" class="input-group-text fee-suffix">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <button type="button" class="btn add-fee-button" (click)="addFee()">
        <i class="bi bi-plus-circle"></i>
        {{ 'Add Fee' | translate }}
      </button>

      <button
        (click)="submit()"
        type="button"
        class="btn fees-submit-button">
        <span *ngIf="isAddFeesSettings && permissionStore">{{ 'Create Fees Settings' | translate }}</span>
        <span *ngIf="isEditFeesSettings && permissionUpdate">{{ 'Update Fees Settings' | translate }}</span>
      </button>
    </form>
  </nb-card-body>
</nb-card>
